import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent, type Analytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { 
  initializeFirestore, 
  persistentLocalCache, 
  persistentMultipleTabManager,
  getFirestore
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCDyOQrgyHrE56IdiIyDcRB4_-vE62VbgA",
  authDomain: "yliulaw-37283.firebaseapp.com",
  projectId: "yliulaw-37283",
  storageBucket: "yliulaw-37283.firebasestorage.app",
  messagingSenderId: "790363877683",
  appId: "1:790363877683:web:3a0fdeb98c6505613b4e46",
  measurementId: "G-4PQR6ZH3SG"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const analyticsPromise: Promise<Analytics | null> = typeof window === 'undefined'
  ? Promise.resolve(null)
  : isSupported()
      .then((supported) => (supported ? getAnalytics(app) : null))
      .catch(() => null);

// Initialize Firestore with the correct database ID. 
export const db = initializeFirestore(app, {}, 'liulaw-db');

export const storage = getStorage(app);

export const trackPageView = async (pagePath: string, pageTitle?: string) => {
  const analytics = await analyticsPromise;

  if (!analytics || typeof window === 'undefined') {
    return;
  }

  logEvent(analytics, 'page_view', {
    page_location: window.location.href,
    page_path: pagePath,
    page_title: pageTitle ?? document.title
  });
};

export default app;
